import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7182bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-wrapper" }

import { useRoute } from 'vue-router';
import LanguageMenu from '@/components/LanguageMenu.vue';
import VideoSelection from '@/components/VideoSelection.vue';
import { IonPage } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSelectionView',
  setup(__props) {

const route = useRoute();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(route).params.language !== undefined)
          ? (_openBlock(), _createBlock(VideoSelection, {
              key: 0,
              language: _unref(route).params.language.toString()
            }, null, 8, ["language"]))
          : _createCommentVNode("", true),
        _createVNode(LanguageMenu)
      ])
    ]),
    _: 1
  }))
}
}

})